import { env, region } from '@fhs-legacy/frontend/src/utils/environment';

export const sanityProjectId = 'czqk28jt';

// env() and region() rely on Expo runtime (expo-constants), which is unavailable in non-Expo contexts (e.g. backend/build).
// We wrap in try-catch to fall back to process.env when Expo isn't available.
function getSafeEnv(): string {
  try {
    return String(env()).toLowerCase() ?? 'dev';
  } catch {
    return process.env.REACT_APP_RBI_ENV ?? 'dev';
  }
}

function getSafeRegion(): string {
  try {
    return String(region()).toLowerCase() ?? 'us';
  } catch {
    return process.env.REACT_APP_RBI_COUNTRY ?? 'us';
  }
}

export const sanityStage = getSafeEnv();
export const sanityRegion = getSafeRegion();
export const useCdn = sanityStage === 'qa' || sanityStage === 'dev' ? false : true;
export const sanityDataset = `${sanityStage}_fhs_${sanityRegion}`;
